'use client';

import { TabText, TabTextItem } from '@musinsa/mds';
import type { CouponGoodsCategoryDto } from '@musinsa/services-curator';

interface CouponGoodsCategoryTabsProps {
  /** "전체" 다음에 노출되는 카테고리 목록 */
  categories: CouponGoodsCategoryDto[];
  /** undefined = 전체 */
  selectedCategoryCode: string | undefined;
  onSelect: (categoryCode: string | undefined) => void;
  className?: string;
}

const ALL_TAB_LABEL = '전체';

export const CouponGoodsCategoryTabs = ({
  categories,
  selectedCategoryCode,
  onSelect,
  className,
}: CouponGoodsCategoryTabsProps) => {
  return (
    <TabText colorScheme="gray" depth="oneDepth" divider="on" wrapperProps={{ className }}>
      <TabTextItem
        isSelected={selectedCategoryCode === undefined}
        disabledUnderline={false}
        onClick={() => onSelect(undefined)}
      >
        {ALL_TAB_LABEL}
      </TabTextItem>
      {categories.map((category) => (
        <TabTextItem
          key={category.categoryCode}
          isSelected={selectedCategoryCode === category.categoryCode}
          disabledUnderline={false}
          onClick={() => onSelect(category.categoryCode)}
        >
          {category.categoryTitle}
        </TabTextItem>
      ))}
    </TabText>
  );
};
